import { render, staticRenderFns } from "./SchoolListView.vue?vue&type=template&id=9ae489b0&"
import script from "./SchoolListView.vue?vue&type=script&lang=js&"
export * from "./SchoolListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports